import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import Thought from "./components/thought.vue";
import Mission from "./components/mission.vue";
import PartyStatistics from "./components/partyStatistics.vue";
import Activity from "./components/activityStatistics.vue";
import PartyPayment from "./components/partyPaymentPay.vue";
import ExamOnline from "./components/examOnlineMain.vue";
import TrainOnline from "./components/train.vue";
import Meeting from "./components/meeting.vue";
import Democracy from "./components/democracy.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "DataScreenIndex",
  components: {
    Thought: Thought,
    Mission: Mission,
    PartyStatistics: PartyStatistics,
    Activity: Activity,
    PartyPayment: PartyPayment,
    ExamOnline: ExamOnline,
    TrainOnline: TrainOnline,
    Meeting: Meeting,
    Democracy: Democracy
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var dataCount = ref({});
    var appStyle = ref();
    var store = useStore();
    var router = useRouter(); // 全部人数

    var getDataScreenPersonTotal = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataScreenPersonTotal"]();

              case 2:
                res = _context.sent;

                if (res.code == 0) {
                  dataCount.value = res.data;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDataScreenPersonTotal() {
        return _ref.apply(this, arguments);
      };
    }();

    onMounted(function () {
      if (store.state.system.demonstration) {
        dataCount.value.orgCount = 78;
        dataCount.value.partyCount = 56;
        dataCount.value.unPartyCount = 12;
      } else {
        getDataScreenPersonTotal();
      } // window.onresize = setHtmlRootSize;
      // return () => {
      //   window.onresize = null;
      // };

    });
    var timer;

    var taskGetPersonTotal = function taskGetPersonTotal() {
      timer = setInterval(function () {
        getDataScreenPersonTotal();
        clearInterval(timer);
        taskGetPersonTotal();
      }, 10000);
    };

    if (!store.state.system.demonstration) {
      taskGetPersonTotal();
    }

    onUnmounted(function () {
      clearInterval(timer);
    });

    function changeStyle() {
      router.push('/greenScreens');
    }

    return {
      appStyle: appStyle,
      dataCount: dataCount,
      getDataScreenPersonTotal: getDataScreenPersonTotal,
      changeStyle: changeStyle
    };
  }
});